<template>
  <TemplateView>
    <div class="container">
      <TemplatePageGrid
        :items="rolesData"
        :page-data="pageData"
        :loading="loadingAnimation"
        sort-az="last_name"
      >
        <template v-slot:buttons>
          <BaseButton
            v-if="
              $userCheckAccess({
                abilities: 'add_roles',
              })
            "
            @click="$router.push({ name: 'SettingRolesCreate' })"
            :text="localStorage.translations.pages['setting-roles'].buttons['sozdat-rol']"
          >
            <template v-slot:icon>
              <svg
                width="15"
                height="17"
                viewBox="0 0 15 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.45029 6.36918C6.32818 6.36918 7.08836 6.05535 7.70948 5.43617C8.3306 4.81709 8.64546 4.0596 8.64546 3.18449C8.64546 2.30968 8.3306 1.5521 7.70937 0.932811C7.08815 0.313829 6.32808 0 5.45029 0C4.5723 0 3.81233 0.313829 3.19121 0.932912C2.57009 1.55199 2.25513 2.30958 2.25513 3.18449C2.25513 4.0596 2.57009 4.81719 3.19131 5.43627C3.81253 6.05525 4.57261 6.36918 5.45029 6.36918Z"
                  fill="#F2F2F2"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.43976 13.2222C7.43976 13.2221 7.43976 13.2221 7.43976 13.2221C7.43976 11.228 8.98982 9.59481 10.9545 9.45416C10.9478 9.41363 10.9407 9.37278 10.9333 9.33162C10.8794 9.03262 10.8101 8.74997 10.7271 8.49162C10.6414 8.2246 10.5248 7.96091 10.3807 7.70821C10.2311 7.44593 10.0554 7.21754 9.85825 7.02961C9.65209 6.833 9.39967 6.67492 9.10779 6.55962C8.81691 6.44492 8.49456 6.38682 8.14974 6.38682C8.01433 6.38682 7.88336 6.4422 7.63044 6.60633C7.47478 6.70751 7.29271 6.82453 7.08948 6.95395C6.9157 7.06431 6.68029 7.16771 6.38952 7.26132C6.10583 7.35282 5.81779 7.39922 5.53349 7.39922C5.2492 7.39922 4.96126 7.35282 4.67727 7.26132C4.3868 7.16781 4.15139 7.06441 3.97781 6.95405C3.77651 6.82584 3.59433 6.70882 3.43635 6.60623C3.18373 6.4421 3.05266 6.38672 2.91724 6.38672C2.57232 6.38672 2.25008 6.44492 1.9593 6.55972C1.66762 6.67482 1.4151 6.8329 1.20874 7.02971C1.01168 7.21774 0.835884 7.44603 0.6865 7.70821C0.54248 7.96091 0.425887 8.2245 0.340062 8.49172C0.257172 8.75007 0.187844 9.03262 0.134001 9.33162C0.0806635 9.628 0.0444307 9.90915 0.0265167 10.1674C0.00890638 10.4204 0 10.683 0 10.9482C0 11.6384 0.220129 12.1971 0.654214 12.6092C1.08294 13.0159 1.65021 13.2222 2.34005 13.2222H7.43976Z"
                  fill="#F2F2F2"
                />
                <path d="M9.375 13.7618H15V14.5713H9.375V13.7618Z" fill="#F2F2F2" />
                <path
                  d="M12.5893 11.3333L12.5893 16.9999H11.7857L11.7857 11.3333L12.5893 11.3333Z"
                  fill="#F2F2F2"
                />
              </svg>
            </template>
          </BaseButton>
        </template>
        <RolesTable
          :rolesData="rolesData"
          :abilitiesData="abilitiesData"
          :rolesConfig="rolesConfig"
        />
      </TemplatePageGrid>
    </div>
  </TemplateView>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import RolesTable from 'components/setting/roles/RolesTable'
import roles_config from '~/configs/setting/roles'

export default {
  name: 'SettingRoles',
  components: {
    RolesTable,
  },
  data() {
    return {
      loadingAnimation: true,
    }
  },
  created() {
    this.downloadPageData()
  },
  watch: {
    '$route.query'() {
      this.downloadPageData()
    },
  },
  computed: {
    ...mapGetters('commonRole', ['rolesData', 'abilitiesData', 'pageData']),
    rolesConfig() {
      return roles_config
    },
  },
  methods: {
    ...mapActions('commonRole', ['listOfRoles', 'listOfAbilities']),
    async downloadPageData() {
      this.loadingAnimation = true
      let data = {
        limit: this.$route.query.limit,
        page: this.$route.query.page,
      }
      if (this.$route.query.sort_param && this.$route.query.sort_value) {
        data.sort = {
          param: this.$route.query.sort_param,
          value: this.$route.query.sort_value,
        }
      }
      if (this.$route.query.search) {
        data.search = this.$route.query.search
      }
      await Promise.all([
        this.listOfRoles(data),
        Object.keys(this.rolesConfig).length,
        this.listOfAbilities(),
      ])
        .then(() => (this.loadingAnimation = false))
        .catch(() => (this.loadingAnimation = false))
    },
  },
}
</script>
